angular.module('angus.controllers').controller('hedgePosSettingsCtrl', [
    '$scope',
    function($scope) {

        function init() {
       
        }

        init();      

    }
]);